import { render, staticRenderFns } from "./RidesPerSchedule.vue?vue&type=template&id=95a905be&scoped=true&"
import script from "./RidesPerSchedule.vue?vue&type=script&lang=js&"
export * from "./RidesPerSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a905be",
  null
  
)

export default component.exports